import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-scan_eye",
  "use": "icon-scan_eye-usage",
  "viewBox": "0 0 280.1 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 280.1 200\" id=\"icon-scan_eye\">\r\n<path d=\"M140,0C40,0,0,100,0,100s40,100,140,100s140-100,140-100S240,0,140,0L140,0z M140,160c-33.1,0-60-26.9-60-60s26.9-60,60-60\r\n\ts60,26.9,60,60C200,133.1,173.1,160,140,160L140,160z M170,100c0,16.6-13.5,30-30,30s-30-13.5-30-30c0-16.6,13.5-30,30-30\r\n\tC156.6,70,170,83.4,170,100L170,100z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol